import { LeftArrow, MenuItems, RightArrow } from 'components/Common/AnitmateLogo';
import React from 'react';
import Link from 'next/link';

type LessonNavigationType = {
  nextLesson: number;
  previousLesson: number;
  onLesson: (lesson) => void;
  mainHref: string;
};

const LessonNavigation: React.FC<LessonNavigationType> = (props) => {
  const { nextLesson, previousLesson, onLesson, mainHref } = props;
  return (
    <div className="h-[70px] center w-full border-b-gray-1 relative px-[40px] border-b font-bold text-[18px]">
      <RightArrow
        disable={!previousLesson}
        className="right-12 absolute"
        onClick={(): void => previousLesson && onLesson(previousLesson)}
      />

      <Link href={mainHref} aria-label="course">
        <a>
          <MenuItems />
        </a>
      </Link>

      <LeftArrow
        disable={!nextLesson}
        className="left-12 absolute"
        onClick={(): void => nextLesson && onLesson(nextLesson)}
      />
    </div>
  );
};

export default LessonNavigation;
